export const FMMixinOther = {
  data() {
    return {
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "整单核销",
          method: "allWriteoff",
        },
        {
          name: "部分核销",
          method: "partWriteoff",
        },
        {
          name: "核销记录",
          method: "writeoffRecord",
        },
        {
          name: "生成对账单",
          method: "generatState",
        },
        {
          type: true,
          name: "更多操作",
          options: [
            {
              handleName: "dc",
              label: "导出",
            },
            {
              handleName: "bgsz",
              label: "表格设置",
            },
            {
              handleName: "dy",
              label: "打印",
            },
          ],
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "doubleSelect",
          label: "结算对象",
          selectItem: [
            {
              field: "objectStatusConfDictId",
              placeholder: "请选择",
              setLabel: "val",
              setValue: "confDictId",
              selectChange: "GetUserDownList",
              selectOptions: [],
            },
            {
              field: "objectName",
              placeholder: "请选择",
              setLabel: "name",
              setValue: "name",
              allowCreate: false,
              selectOptions: [],
            },
          ],
        },
        {
          type: "doubleSelect",
          label: "费项",
          selectItem: [
            {
              field: "categoryId",
              placeholder: "请选择",
              setLabel: "categoryName",
              setValue: "categoryId",
              selectChange: "GetExpenditure",
              selectOptions: [],
            },
            {
              field: "serviceId",
              placeholder: "请选择",
              setLabel: "title",
              setValue: "itemServiceId",
              selectOptions: [],
            },
          ],
        },
        {
          type: "select",
          label: "单据类型",
          field: "documentStatus",
          placeholder: "请选择",
          setLabel: "showName",
          setValue: "statusVal",
          selectOptions: [],
        },
        {
          type: "input",
          label: "来源单号",
          field: "documentNumber",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "核销状态",
          field: "writeoffStatus",
          placeholder: "请选择",
          setLabel: "showName",
          setValue: "statusVal",
          selectOptions: [],
        },
        {
          type: "deptTree",
          label: "责任部门",
          field: "dutyDeptIds",
          setLabel: "departmentName",
          setValue: "deptId",
          placeholder: "请选择",
          selectOptions: [],
        },
        {
          type: "select",
          label: "对账单",
          field: "hasCreateStatement",
          placeholder: "请选择",
          setLabel: "name",
          setValue: "value",
          selectOptions: [
            {
              name: "已生成",
              value: '1',
            },
            {
              name: "未生成",
              value: '0',
            },
          ],
        },
      ],
      queryData: {
        categoryId: null,
        serviceId: null,
        documentNumber: null,
        documentStatus: null,
        dutyDeptId: null,
        endCreateTime: null,
        number: null,
        objectName: null,
        startCreateTime: null,
        writeoffStatus: null,
        hasCreateStatement: '0',
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "业务日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      // 整单核销弹窗
      diaWidth: "60%",
      isShowDialog_1: false,
      diaFormConfig: [
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: "核销金额",
              itemType: "input",
              field: "moneys",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "核销资金账号",
              itemType: "select",
              field: "accountId",
              placeholder: "请选择",
              labelwidth: 120,
              setLabel: "account",
              setValue: "assetaccountId",
              options: [],
            },
            {
              span: 8,
              title: "核销时间",
              itemType: "datetime",
              field: "writeOffTime",
              placeholder: "选择时间",
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "writeoffComment",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "图片",
              itemType: "upload",
              slot: "phone",
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: "操作时间",
              itemType: "input",
              field: "oprationTime",
              disabled: true,
              placeholder: "自动填写",
            },
            {
              span: 8,
              title: "操作人",
              itemType: "input",
              field: "oprationer",
              disabled: true,
              placeholder: "自动填写",
            },
          ],
        },
      ],
      baseModel: {
        moneys: 0,
        oprationer: "",
        oprationTime: "",
      },
      fileNameLists: [],
      defaultBaseModel: {
        accountId: null,
        financeIds: null,
        writeOffPics: null,
        writeOffTime: null,
        writeoffComment: null,
      },
      formRules_1: {
        writeOffTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        accountId: [{ required: true, message: "请选择", trigger: "change" }],
      },
      // 部分核销
      isShowDialog_2: false,
      diaFormConfig_2: [
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: "总金额",
              itemType: "input",
              field: "allmoneys",
              labelwidth: 120,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "本次核销金额",
              itemType: "input",
              labelwidth: 120,
              field: "writeoffAmount",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "剩余核销金额",
              itemType: "input",
              field: "surplusmoney",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: "核销资金账号",
              itemType: "select",
              field: "accountId",
              placeholder: "请选择",
              labelwidth: 120,
              setLabel: "account",
              setValue: "assetaccountId",
              options: [],
            },
            {
              span: 8,
              title: "核销时间",
              itemType: "datetime",
              field: "writeOffTime",
              placeholder: "选择时间",
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "writeoffComment",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "图片",
              itemType: "upload",
              slot: "phone",
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: "操作时间",
              itemType: "input",
              field: "oprationTime",
              disabled: true,
              placeholder: "自动填写",
            },
            {
              span: 8,
              title: "操作人",
              itemType: "input",
              field: "oprationer",
              disabled: true,
              placeholder: "自动填写",
            },
          ],
        },
      ],
      baseModel_2: {
        allmoneys: 0,
        surplusmoney: 0,
        oprationTime: "",
        oprationer: "",
      },
      defaultBaseModel_2: {
        accountId: null,
        financeId: null,
        writeOffPics: null,
        writeOffTime: null,
        writeoffAmount: null,
        writeoffComment: null,
      },
      fileNameLists_2: [],
      formRules_2: {
        writeOffTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        writeoffAmount: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        accountId: [{ required: true, message: "请选择", trigger: "change" }],
      },
      // 核销记录
      isShowDialog_3: false,
      // 表格配置
      writeoffTable: {
        maxHeight: "75vh",
        tableData: [],
      },
      W_tableHeads: [
        {
          name: "操作",
          field: "edit",
          method: "ReWriteoff",
          methodName: "反核销",
        },

        {
          name: "总金额",
          field: "settlementAmount",
          width: "120",
        },
        {
          name: "核销类型",
          field: "operationTypeShow",
          width: "120",
        },
        {
          name: "已核销金额",
          field: "writeoffedAmount",
          width: "120",
        },
        {
          name: "本次核销金额",
          field: "writeoffAmount",
          width: "160",
        },
        {
          name: "剩余待核销金额",
          field: "unwriteoffAmount",
          width: "160",
        },
        {
          name: "核销资金账号",
          field: "zjAccount",
          width: "120",
        },
        {
          name: "核销人",
          field: "writeoffUserName",
          width: "120",
        },
        {
          name: "核销时间",
          field: "writeoffTime",
          width: "120",
        },
        {
          name: "核销备注",
          field: "writeoffComment",
          width: "120",
        },
        {
          name: "操作时间",
          field: "operationTime",
          width: "120",
        },
        {
          name: "图片",
          width: "120",
          hasButton: true,
          disabled: false,
          method: "viewImages",
          methodName: "点击查看",
        },
      ],
      srcList: [],
      dialogVisible: false,
    };
  },
  methods: {
    // 获取结算对象类型
    getConfDictValDownList(PARAM) {
      this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
        if (res.data.status === "success") {
          this.baseConfig[1].selectItem[0].selectOptions =
            res.data.result || [];
        } else {
          console.log(res.data.message);
        }
      });
    },
    // 根据结算对象类型获取结算对象
    GetUserDownList(e) {
      if (e) {
        let arr = this.baseConfig[1].selectItem[0].selectOptions;
        let num = arr.findIndex((element) => element.confDictId == e);
        let objectKey = arr[num].key;
        // 结算对象为其他的时候自动输入
        if (objectKey === "other") {
          this.queryData.objectName = "";
          this.baseConfig[1].selectItem[1].allowCreate = true;
          this.baseConfig[1].selectItem[1].placeholder = "请输入";
          this.baseConfig[1].selectItem[1].selectOptions = [];
        } else {
          this.baseConfig[1].selectItem[1].allowCreate = false;
          this.baseConfig[1].selectItem[1].placeholder = "请选择";
          this.$API
            .wtl_getObjectUserDownList({
              key: objectKey,
              pageStart: 1,
              pageTotal:1000,
            })
            .then((res) => {
              if (res.data.status === "success") {
                let result = res.data.result.data || [];
                this.queryData.objectName = "";
                this.baseConfig[1].selectItem[1].selectOptions = result;
              }
            });
        }
      } else {
        this.queryData.objectName = "";
        this.baseConfig[1].selectItem[1].selectOptions = [];
      }
    },
    // 获取费项类型下拉列表
    GetItemCategorChoose() {
      this.$API.itemCategorChoose().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result || [];
          this.baseConfig[2].selectItem[0].selectOptions = result;
        }
      });
    },

    // 根据类别和费项类型获取费项
    GetExpenditure(e) {
      if (e) {
        this.$API.CategoryServiceList({ categoryId: e }).then((res) => {
          if (res.data.status === "success") {
            let result = res.data.result || [];
            this.queryData.serviceId = "";
            this.baseConfig[2].selectItem[1].selectOptions = result;
          }
        });
      } else {
        this.queryData.serviceId = "";
        this.baseConfig[2].selectItem[1].selectOptions = [];
      }
    },

    // 获取对象单据类型 & 核销状态
    async GetStatusValList() {
      // 获取应收核销状态
      this.$TOOLS
        .getStatusValList("finance_in_record_v1.writeoff_status")
        .then((res) => {
          this.baseConfig[5].selectOptions = res;
        });
      // 获取应收单据类型
      let res = await this.$TOOLS
        .getStatusValList("finance_in_record_v1.document_status")
        .then((res) => {
          return res;
        });
      // 获取应付单据类型
      let res1 = await this.$TOOLS
        .getStatusValList("finance_out_record_v1.document_status")
        .then((res) => {
          return res;
        });
      this.baseConfig[3].selectOptions = [...res, ...res1];
    },
    // 获取业务部门（组织架构列表）
    GetDept() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result.data || [];
          this.baseConfig[6].selectOptions = result;
        }
      });
    },
    // 获取核销记录
    getRecord(id, type) {
      if (type == "financeOut") {
        // 应付核销记录
        this.$API.FinanceOutWriteoffRecorList({ financeId: id }).then((res) => {
          if (res.data.status === "success") {
            this.writeoffTable.tableData = res.data.result || [];
          } else {
            console.log(res.data.message);
          }
        });
      }
      if (type == "financeIn") {
        // 应收核销记录
        this.$API.FinanceInWriteoffRecorList({ financeId: id }).then((res) => {
          if (res.data.status === "success") {
            this.writeoffTable.tableData = res.data.result || [];
          } else {
            console.log(res.data.message);
          }
        });
      }
    },

    // 财务返核销
    FinanceInUnWriteOff(id) {
      this.$API.financeInUnWriteOff({ recordId: id }).then((res) => {
        if (res.data.status === "success") {
          this.getRecord(
            this.selectTableData[0].financeId,
            this.selectTableData[0].financeType
          );
          this.$message.success(res.data.message);
        } else {
          console.log(res.data.message);
        }
      });
    },

    // 整单核销
    allWriteoff(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        let moneyNum = 0;
        this.baseModel.financeIds = [];
        this.baseModel.oprationer = this.selectTableData[0].writeoffUserName;
        this.baseModel.financeType = this.selectTableData[0].financeType;
        this.baseModel.oprationTime = this.selectTableData[0].createTime;
        for (let i in this.selectTableData) {
          moneyNum += Number(this.selectTableData[i].settlementAmount);
          this.baseModel.financeIds.push(this.selectTableData[i].financeId);
        }
        this.baseModel.moneys = moneyNum.toFixed(2);
        this.isShowDialog_1 = true;
      }
    },
    // 部分核销
    partWriteoff(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.baseModel_2.allmoneys = this.selectTableData[0].settlementAmount;
        this.baseModel_2.surplusmoney = this.selectTableData[0].unwriteoffAmount;
        this.baseModel_2.financeId = this.selectTableData[0].financeId;
        this.baseModel.financeType = this.selectTableData[0].financeType;
        this.baseModel_2.oprationTime = this.selectTableData[0].createTime;
        this.baseModel_2.oprationer = this.selectTableData[0].writeoffUserName;
        this.isShowDialog_2 = true;
      }
    },
    // 核销记录
    writeoffRecord(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.getRecord(
          this.selectTableData[0].financeId,
          this.selectTableData[0].financeType
        );
        this.isShowDialog_3 = true;
      }
    },
    rowCallback(data, name) {
      this[name](data);
    },
    // 筛选表单选择框清空时
    ClearSelect() {
      console.log(111);
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 当前弹窗的标题赋值
    dialogTitle(e) {
      return e === 1
        ? "整单核销"
        : e === 2
        ? "部分核销"
        : e === 3
        ? "核销记录"
        : "编辑";
    },
    // 查询框对象字段级联事件
    ObjectChange(e) {
      console.log(e);
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.queryData.objectName = "";
      this.queryData.objectStatusConfDictId = "";
      this.queryData.categoryId = "";
      this.queryData.serviceId = "";
      this.GetData();
    },

    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },

    // 整单核销
    //  弹窗确认保存事件
    diaConfirmBtn(e) {
      if (e == 1) this.ZDcomfirm();
      if (e === 2) this.BFcomfirm();
      if (e === 3) this.recordComfirm();
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(e) {
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      if (e == 1) {
        this.baseModel = {
          moneys: 0,
          oprationer: "",
          oprationTime: "",
        };
        this.isShowDialog_1 = false;
      } else if (e === 2) {
        this.baseModel_2 = {
          allmoneys: 0,
          surplusmoney: 0,
          oprationTime: "",
          oprationer: "",
        };
        this.isShowDialog_2 = false;
      } else if (e === 3) this.isShowDialog_3 = false;
    },

    handleCloseDia(e) {
      this.diaCancelBtn(e);
    },
    // 整单核销选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 部分核销选择图片
    changeFileList_2(array) {
      this.fileNameLists_2 = array;
    },
    // 核销记录确认按钮
    recordComfirm() {
      this.isShowDialog_3 = false;
    },

    // 整单核销确认按钮
    ZDcomfirm() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          param.writeOffPics = [];
          for (let i in this.fileNameLists) {
            param.writeOffPics.push(this.fileNameLists[i].name);
          }
          param.financeIds = this.baseModel.financeIds;
          // 修改接口
          if (this.baseModel.financeType == "financeIn") {
            // 应收整单核销
            this.$API.financeInWriteOff(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog_1 = false;
                this.GetData();
              }
            });
          } else {
            // 应付整单核销
            this.$API.financeOutWriteOff(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog_1 = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 部分核销确认按钮
    BFcomfirm() {
      this.$refs["diaform_2"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel_2) {
            if (this.baseModel_2[key]) {
              eval("param." + key + "='" + this.baseModel_2[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          param.writeOffPics = [];
          for (let i in this.fileNameLists_2) {
            param.writeOffPics.push(this.fileNameLists_2[i].name);
          }

          if (this.baseModel.financeType == "financeIn") {
            // 应收部分核销
            this.$API.financeInPartWriteOff(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog_2 = false;
                this.GetData();
              }
            });
          } else {
            // 应付部分核销
            this.$API.financeOutPartWriteOff(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog_2 = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 生成对账单
    generatState(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 0) {
        this.$message.error("请选择至少一条数据进行操作");
        return false;
      } else {
        let arr = [];
        let d = this.selectTableData;
        if (this.selectTableData.length > 0) {
          for (let i in d) {
            if (
              d[i].objectName == d[0].objectName &&
              d[i].writeoffStatus !== "yi_he_xiao:writeoff_status"
            ) {
              arr.push({
                type: d[i].financeType,
                number: d[i].number,
              });
            } else {
              this.$message.error("存在已核销数据或结算对象不同");
              return false;
            }
          }
        }
        let billval = {
          name: this.pageGroupName,
          val: arr,
        };
        sessionStorage.setItem("Bill", JSON.stringify(billval));
        this.$router.push({
          path: "/FM/ClearingBill/1",
          query: {
            category: this.pageGroupName,
          },
        });
        this.selectTableData = [];
      }
    },
    // 财务反核销
    ReWriteoff(e) {
      this.$API.financeInUnWriteOff({ recordId: e.recordId }).then((res) => {
        if (res.data.status === "success") {
          this.$message.success(res.data.message);
          this.getRecord(this.selectTableData[0].financeId);
        } else {
          this.$message.warning(res.data.message);
        }
      });
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableConfig.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
  },
  created() {
    let permissValArr = [];
    // if (this.tableType === "finance_in") {
    permissValArr = [
      "admin:finance_all:financeInPartWriteOff",
      "admin:finance_all:financeInWriteOff",
      "admin:finance_all:getFinanceInWriteoffRecorList",
      "admin:finance_all:createStatement",
    ];
    // }
    // if (this.tableType === "finance_out") {
    // permissValArr = ['admin:finance_all:financeOutWriteOff', 'admin:finance_all:financeOutPartWriteOff', 'admin:finance_all:getFinanceOutWriteoffRecorList', 'admin:finance_all:createStatement']
    // }
    for (let i in permissValArr) {
      this.BTN_CONFIG[i].permissVal = permissValArr[i];
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.getConfDictValDownList("object_status");
    this.getAssetaccountList();
    this.GetItemCategorChoose();
    this.GetStatusValList();
    this.GetDept();
  },
};
